<!-- 顶部功能栏 -->

<template>
    <div class="e-top-bar-container">
        <div class="e-left-bar">
            <i
                    class="e-icon el-icon-s-unfold"
                    :class="{ active: data_menu_lock }"
                    @click="lockMenu"
                    @mouseover="menuMouseStatusChange(true)"
                    @mouseout="menuMouseStatusChange(false)"
            >
                <i
                        v-show="data_menu_lock"
                        class="e-menu-lock el-icon-lock"
                ></i>
            </i>
            <span class="e-divider"></span>
        </div>
        <div class="e-center-bar">
            <div class="e-center-bar">
                <div class="e-title-info">
                    <div class="e-logo" style="background-image: url('favicon.png');" ></div>
                    <span class="e-name">{{title_info.name}}</span>
                </div>
            </div>
        </div>
        <div class="e-right-bar">

            <el-dropdown class="e-user-info-dropdown">
                <i class="e-icon el-icon-bell">
                    <span class="e-badge" v-if="messageNumber != 0">{{messageNumber}}</span>
                </i>
                <el-dropdown-menu slot="dropdown">
                    <message-list @updateNumber="updateMessageNumber"></message-list>
                </el-dropdown-menu>
            </el-dropdown>
            <span class="e-divider"></span>
            <el-dropdown class="e-user-info-dropdown" @command="handleUserMenuItem">
                <div class="e-user-info">
                    <img class="e-user-header" src="user-avatar.jpg"/>
                    <span>{{user_info.name}}</span>
                </div>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="update_password">修改密码</el-dropdown-item>
                    <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>

        </div>
    </div>

</template>

<script>
    import MessageList from "@/components/message-list/index";

    export default {
        components: {
            MessageList
        },
        data() {
            return {
                data_menu_lock: false,
                messageNumber: 0
            }
        },
        props: {
            menu_lock: {
                default: false
            },
            title_info: {},
            user_info: {}
        },

        computed: {},

        watch: {
            menu_lock() {
                this.data_menu_lock = this.menu_lock;
            }
        },

        mounted() {
            this.data_menu_lock = this.menu_lock;
        },

        methods: {
            lockMenu() {
                this.data_menu_lock = !this.data_menu_lock;
                if (this.data_menu_lock) {
                    this.$emit('menu_collapse_change', false)
                }
                this.$emit('update:menu_lock', this.data_menu_lock)
            },
            menuMouseStatusChange(hover) {
                if (this.data_menu_lock) {
                    return
                }
                this.$emit('menu_collapse_change', !hover)
            },
            handleUserMenuItem(command) {
                this.$emit('user_info_item_click', command);
            },
            updateMessageNumber(e) {
                this.messageNumber = e >= 9 ? '9+' : e;
            }
        }
    }

</script>

<style scoped lang='scss'>
    @import 'style.scss';
</style>
